import DetailRealisasiProduksi from './DetailRealisasiProduksi';

export default DetailRealisasiProduksi;
